<template>
  <div class="organization-wrapper detail-wrapper full-height scroll-y border-top" v-if="hasOrganization">
    <div class="panel panel-heading m-b-0 m-t-0 p-t-0">
      <div @click="$refs.importInput.click()" class="btn-link"><i class="pg-sent"></i>IMPORT</div>
      <div @click="exportData" class="btn-link"><i class="pg-download"></i>EXPORT CORE</div>
      <div @click="exportGeoData" class="btn-link"><i class="pg-download"></i>EXPORT GEOJSON</div>
      <div @click="resetPassword" class="btn-link text-danger"><i class="pg-refresh"></i>RESET PASSWORD</div>
      <div class="btn-link btn-disabled text-danger"><i class="pg-home"></i>BLOCK ACCOUNT</div>
      <div class="clearfix"></div>
      <h1><strong>{{ organization.company }}</strong> / {{ organization.name }}</h1>
    </div>

    <div class="import-form hide">
      <form ref="importForm" enctype="multipart/form-data" onSubmit.preventDefault="importData" novalidate>
        <input type="file" v-on:change="onImport" ref="importInput" accept="application/json" />
      </form>
    </div>

    <div class="panel m-t-0 p-t-0 p-l-20">
      <ul class="nav nav-tabs nav-tabs-simple">
        <li class="active">
          <a data-toggle="tab" href="#tab-overview">Overview</a>
        </li>
        <li v-if="false">
          <a data-toggle="tab" href="#tab-invoicing">Invoicing</a>
        </li>
        <li>
          <a data-toggle="tab" href="#tab-geodata">Geo Data</a>
        </li>
        <li v-if="isAdmin()">
          <a data-toggle="tab" href="#tab-data">Data</a>
        </li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane active" id="tab-overview">
          <div class="row p-b-20">
            <div class="col-lg-3 col-md-3">
              <h4 :class="{
            'bold no-margin': true,
            'text-success': organization.plan === 'free',
            'text-primary': organization.plan === 'guru' && !isExpired(organization),
            'text-warning': isExpired(organization),
            }">{{ organization.plan }} <slot v-if="isExpired(organization)">(expired)</slot></h4>
              <div class="pull-left">
                <p class="small no-margin">Active plan</p>
              </div>
              <div class="pull-right">
                <p class="small text-success bold cursor">CHANGE</p>
              </div>
            </div>
            <div class="col-lg-3 col-md-3">
              <h5 class="bold no-margin p-t-5">
                <date-picker
                  :first-day-of-week="1"
                  type="datetime"
                  format="dd.MM.yyyy HH:mm"
                  :confirm="true"
                  lang="en"
                  width="100%"
                  :not-before="new Date()"
                  confirm-text="Confirm"
                  ref="expirePicker"
                  v-on:confirm="setExpirationDate"
                  v-model="expirationDate"></date-picker>
              </h5>
              <div class="pull-left">
                <p class="small no-margin">Expires At</p>
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="col-lg-3 col-md-3">
              <h5 class="bold no-margin p-t-5">{{ $format.date(organization.createdAt) }}</h5>
              <p class="small no-margin">Registered since</p>
            </div>
            <div class="col-lg-3 col-md-3">
              <h5 class="bold no-margin p-t-5">155</h5>
              <p class="small no-margin">Unique Visitors</p>
            </div>
          </div>
          <div class="row column-seperation border-top">
            <div class="col-md-6">
              <h3 class="semi-bold text-center">Registration</h3>
              <table class="table no-padding no-margin small-table">
                <tr>
                  <th class="col-lg-6 no-margin">Company</th>
                  <td class="col-lg-6 no-margin">{{ organization.company }}</td>
                </tr>
                <tr>
                  <th class="col-lg-6 no-margin">User</th>
                  <td class="col-lg-6 no-margin">{{ organization.name }}</td>
                </tr>
                <tr>
                  <th class="col-lg-6 no-margin">Email</th>
                  <td class="col-lg-6 no-margin"><a :href="`mailto:${organization.mail}`">{{ organization.email }}</a></td>
                </tr>
                <tr>
                  <th class="col-lg-6 no-margin">Country</th>
                  <td class="col-lg-6 no-margin">{{ organization.country }}</td>
                </tr>
                <tr>
                  <th class="col-lg-6 no-margin">Background</th>
                  <td class="col-lg-6 no-margin">{{ organization.background }}</td>
                </tr>
                <tr>
                  <th class="col-lg-6 no-margin">Contact Us</th>
                  <td class="col-lg-6 no-margin">{{ organization.contact_us ? 'YES' : 'NO' }}</td>
                </tr>
                <tr>
                  <th class="col-lg-6 no-margin">Registered At</th>
                  <td class="col-lg-6 no-margin">{{ $format.date(organization.createdAt) }}</td>
                </tr>
                <tr v-if="isAdmin()">
                  <th class="col-lg-6 no-margin">Access Token</th>
                  <td class="col-lg-6 no-margin">
                    <div class="token-wrapper">
                      <span v-if="!showToken" @click="showToken = true" class="pointer text-success bold">show token</span>
                      <span v-if="showToken">{{ organization.tokens[0] }}</span>
                    </div>
                  </td>
                </tr>
                <tr v-if="isAdmin()">
                  <th class="col-lg-6 no-margin">ID</th>
                  <td class="col-lg-6 no-margin">{{ organization.id }}</td>
                </tr>
              </table>
            </div>
            <div class="col-md-6">
              <h3 class="semi-bold text-center">Usage Overview</h3>
              <table class="table small-table">
                <tr>
                  <th class="col-lg-6 no-margin">Places</th>
                  <td :class="{
                    'col-lg-6 no-margin bold': true,
                    'text-success': this.data.places.length > 0,
                    'text-danger': this.data.places.length === 0}">
                    {{ this.data.places.length }}</td>
                </tr>
                <tr>
                  <th class="col-lg-6 no-margin">Floors</th>
                  <td :class="{
                    'col-lg-6 no-margin bold': true,
                    'text-success': this.data.floors.length > 0,
                    'text-danger': this.data.floors.length === 0}">{{ this.data.floors.length }}</td>
                </tr>
                <tr>
                  <th class="col-lg-6 no-margin">Departments</th>
                  <td :class="{
                    'col-lg-6 no-margin bold': true,
                    'text-success': this.data.departments.length > 0,
                    'text-danger': this.data.departments.length === 0}">{{ this.data.departments.length }}</td>
                </tr>
                <tr>
                  <th class="col-lg-6 no-margin">Geofences</th>
                  <td :class="{
                    'col-lg-6 no-margin bold': true,
                    'text-success': this.data.geofences.length > 0,
                    'text-danger': this.data.geofences.length === 0}">{{ this.data.geofences.length }}</td>
                </tr>
                <tr>
                  <th class="col-lg-6 no-margin">Inputs</th>
                  <td :class="{
                    'col-lg-6 no-margin bold': true,
                    'text-success': this.data.inputs.length > 0,
                    'text-danger': this.data.inputs.length === 0}">{{ this.data.inputs.length }}</td>
                </tr>
                <tr>
                  <th class="col-lg-6 no-margin">Node-RED Flows</th>
                  <td :class="{
                    'col-lg-6 no-margin bold': true,
                    'text-success': this.data.red_flows.length > 0,
                    'text-danger': this.data.red_flows.length === 0}">{{ this.data.red_flows.length }}</td>
                </tr>
                <slot v-if="false">
                  <tr>
                    <th class="col-lg-6 no-margin">Unique Visitors</th>
                    <td class="col-lg-6 no-margin">155</td>
                  </tr>
                  <tr>
                    <th class="col-lg-6 no-margin">API Requests Today</th>
                    <td class="col-lg-6 no-margin">752</td>
                  </tr>
                  <tr>
                    <th class="col-lg-6 no-margin">API Requests (7 days)</th>
                    <td class="col-lg-6 no-margin">5401</td>
                  </tr>
                  <tr>
                    <th class="col-lg-6 no-margin">API Requests (30d)</th>
                    <td class="col-lg-6 no-margin">25312</td>
                  </tr>
                  <tr>
                    <th class="col-lg-6 no-margin">Position Updates</th>
                    <td class="col-lg-6 no-margin">52341</td>
                  </tr>
                  <tr>
                    <th class="col-lg-6 no-margin">Enter / Exit Events</th>
                    <td class="col-lg-6 no-margin">1421</td>
                  </tr>
                </slot>
              </table>
            </div>
          </div>
        </div>

        <div class="tab-pane" id="tab-geodata">
          <div class="row">
            <div class="col-md-2 bold">POIs</div>
            <div class="col-md-2 h-40">{{ geodata.filter(f => f.properties.usecase === 'poi').length }}</div>
            <div class="col-md-2 h-40"><div @click="exportGeoItems('pois', f => f.properties.usecase === 'poi')" class="btn btn-xs">EXPORT</div></div>
            <div class="col-md-2 h-40"><div @click="geoWipe('pois')" class="btn btn-danger btn-xs">WIPE</div></div>
          </div>
          <div class="row">
            <div class="col-md-2 bold">Level Changers</div>
            <div class="col-md-2 h-40">{{ geodata.filter(f => f.properties.usecase === 'levelchanger').length }}</div>
            <div class="col-md-2 h-40"><div @click="exportGeoItems('levelchangers', f => f.properties.usecase === 'levelchanger')" class="btn btn-xs">EXPORT</div></div>
            <div class="col-md-2 h-40"><div @click="geoWipe('levelchangers')" class="btn btn-danger btn-xs">WIPE</div></div>
          </div>
          <div class="row">
            <div class="col-md-2 bold">Paths</div>
            <div class="col-md-2 h-40">{{ geodata.filter(f => f.properties.class === 'path').length }}</div>
            <div class="col-md-2 h-40"><div @click="exportGeoItems('paths', f => f.properties.class === 'path')" class="btn btn-xs">EXPORT</div></div>
            <div class="col-md-2 h-40"><div @click="geoWipe('paths')" class="btn btn-danger btn-xs">WIPE</div></div>
          </div>
          <div class="row">
            <div class="col-md-2 bold">Others</div>
            <div class="col-md-2 h-40">{{ geodata.filter(f => f.properties.class !== 'path' && f.properties.usecase !== 'poi' && f.properties.usecase !== 'levelchanger').length }}</div>
            <div class="col-md-2 h-40"><div @click="exportGeoItems('other', f => f.properties.class !== 'path' && f.properties.usecase !== 'poi' && f.properties.usecase !== 'levelchanger')" class="btn btn-xs">EXPORT</div></div>
            <div class="col-md-2 h-40"><div @click="geoWipe('other')" class="btn btn-danger btn-xs">WIPE</div></div>
          </div>
        </div>

        <div class="tab-pane" id="tab-data" v-if="isAdmin()">

          <ul class="nav nav-tabs nav-tabs-simple nav-tabs-left no-padding no-margin">
            <li class="active no-padding no-margin">
              <a data-toggle="tab" href="#tab-data-places" class="p-l-0">
                Places <span :class="{
                  'bold': true,
                  'text-success': data.places.length > 0,
                  'text-warning': data.places.length === 0
                  }">{{ data.places.length }}</span>
              </a>
            </li>
            <li>
              <a data-toggle="tab" href="#tab-data-floors" class="p-l-0">
                Floors <span :class="{
                  'bold': true,
                  'text-success': data.floors.length > 0,
                  'text-warning': data.floors.length === 0
                  }">{{ data.floors.length }}</span>
              </a>
            </li>
            <li>
              <a data-toggle="tab" href="#tab-data-departments" class="p-l-0">
                Departments <span :class="{
                  'bold': true,
                  'text-success': data.departments.length > 0,
                  'text-warning': data.departments.length === 0
                  }">{{ data.departments.length }}</span>
              </a>
            </li>
            <li>
              <a data-toggle="tab" href="#tab-data-geofences" class="p-l-0">
                Geofences <span :class="{
                  'bold': true,
                  'text-success': data.geofences.length > 0,
                  'text-warning': data.geofences.length === 0
                  }">{{ data.geofences.length }}</span>
              </a>
            </li>
            <li>
              <a data-toggle="tab" href="#tab-data-inputs" class="p-l-0">
                Inputs <span :class="{
                  'bold': true,
                  'text-success': data.inputs.length > 0,
                  'text-warning': data.inputs.length === 0
                  }">{{ data.inputs.length }}</span>
              </a>
            </li>
            <li>
              <a data-toggle="tab" href="#tab-data-applications" class="p-l-0">
                Applications <span :class="{
                  'bold': true,
                  'text-success': data.applications.length > 0,
                  'text-warning': data.applications.length === 0
                  }">{{ data.applications.length }}</span>
              </a>
            </li>
          </ul>

          <div class="tab-content p-t-0">
            <div class="tab-pane slide-left active" id="tab-data-places" >
              <div class="row p-l-10 p-r-10">
                <h2 class="p-l-10">Places</h2>
                <div class="place-box col-md-6" v-for="place in data.places" v-bind:key="place.id">
                  <h4>{{ place.name }}</h4>
                  <div class="row">
                    <div class="col-md-4 bold">id</div>
                    <div class="col-md-8">{{ place.id }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">address</div>
                    <div class="col-md-8 h-40">{{ place.address }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">tags</div>
                    <div class="col-md-8">
                      <slot v-if="place.tags">
                        {{ place.tags.join(", ") }}
                      </slot>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">latitude</div>
                    <div class="col-md-8"><slot v-if="place.location">{{ place.location.lat }}</slot></div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">longitude</div>
                    <div class="col-md-8"><slot v-if="place.location">{{ place.location.lng }}</slot></div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">raw data</div>
                    <div class="col-md-8"><span @click="$bus.$emit('raw', place)" class="pointer text-success bold">show</span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane slide-left" id="tab-data-floors" >
              <div class="row p-l-10 p-r-10">
                <h2 class="p-l-10">Floors</h2>
                <div class="floor-box col-md-6" v-for="floor in data.floors" v-bind:key="floor.id">
                  <h4>{{ floor.name }}</h4>
                  <div class="row">
                    <div class="col-md-4 bold">id</div>
                    <div class="col-md-8">{{ floor.id }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">place</div>
                    <div class="col-md-8">{{ floor.place_name }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">level</div>
                    <div class="col-md-8">{{ floor.level }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">floorplan url</div>
                    <div class="col-md-8 break-word">{{ floor.floorplan_image_url }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">anchors</div>
                    <div class="col-md-8">
                      <div class="anchor" v-for="(anchor, index) in floor.anchors" v-bind:key="index">
                        <span class="small">{{ anchor.lat }}</span> / <span class="small">{{ anchor.lng }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">raw data</div>
                    <div class="col-md-8"><span @click="$bus.$emit('raw', floor)" class="pointer text-success bold">show</span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane slide-left" id="tab-data-departments" >
              <div class="row p-l-10 p-r-10">
                <h2 class="p-l-10">Departments</h2>
                <div class="departments-box col-md-6" v-for="department in data.departments" v-bind:key="department.id">
                  <h4>{{ department.name }}</h4>
                  <div class="row">
                    <div class="col-md-4 bold">id</div>
                    <div class="col-md-8">{{ department.id }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">place</div>
                    <div class="col-md-8">{{ department.place_name }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">floor</div>
                    <div class="col-md-8">{{ department.floor_name }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">geofences</div>
                    <div class="col-md-8">{{ data.geofences.filter((g) => g.department_id === department.id).map((i) => i.name).join(", ") }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">inputs</div>
                    <div class="col-md-8">{{ data.inputs.filter((i) => i.department_id === department.id).map((i) => i.name).join(", ") }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">raw data</div>
                    <div class="col-md-8"><span @click="$bus.$emit('raw', department)" class="pointer text-success bold">show</span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane slide-left" id="tab-data-geofences" >
              <div class="row p-l-10 p-r-10">
                <h2 class="p-l-10">Geofences</h2>
                <div class="geofences-box col-md-6" v-for="geofence in data.geofences" v-bind:key="geofence.id">
                  <h4>{{ geofence.name }}</h4>
                  <div class="row">
                    <div class="col-md-4 bold">id</div>
                    <div class="col-md-8">{{ geofence.id }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">place</div>
                    <div class="col-md-8">{{ geofence.place_name }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">floor</div>
                    <div class="col-md-8">{{ geofence.floor_name }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">department</div>
                    <div class="col-md-8">{{ geofence.department_name }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">radius</div>
                    <div class="col-md-8">{{ geofence.radius }}m</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">area</div>
                    <div class="col-md-8">
                      <span class="small">{{ geofence.area.lat }}</span> / <span class="small">{{ geofence.area.lng }}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">polygon</div>
                    <div class="col-md-8">
                      <span
                        @click="shownPolygons[geofence.id] = true; update()"
                        v-if="geofence.polygon && typeof shownPolygons[geofence.id] === 'undefined'"
                        class="pointer text-success bold">show polygon</span>
                      <slot v-if="shownPolygons[geofence.id] === true">
                        <div class="anchor" v-for="(anchor, index) in geofence.polygon" v-bind:key="index">
                          <span class="small">{{ anchor[0] }}</span> / <span class="small">{{ anchor[1] }}</span>
                        </div>
                      </slot>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">raw data</div>
                    <div class="col-md-8"><span @click="$bus.$emit('raw', geofence)" class="pointer text-success bold">show</span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane slide-left" id="tab-data-inputs" >
              <div class="row p-l-10 p-r-10">
                <h2 class="p-l-10">Inputs</h2>
                <div :class="{
                  'geofences-box col-md-6': true,
                  'input-ibeacon': input.type === 'iBeacon',
                  'input-eddystone': input.type === 'Eddystone Beacon'}"
                  v-for="input in _.sortBy(data.inputs, 'name')" v-bind:key="input.id">
                  <h4>{{ input.name }}</h4>
                  <div class="row">
                    <div class="col-md-4 bold">id</div>
                    <div class="col-md-8">{{ input.id }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">type</div>
                    <div class="col-md-8">{{ input.type }}</div>
                  </div>
                  <div class="row" v-if="input.type === 'Eddystone Beacon'">
                    <div class="col-md-4 bold">namespace</div>
                    <div class="col-md-8">{{ input.data.namespace }}</div>
                  </div>
                  <div class="row" v-if="input.type === 'Eddystone Beacon'">
                    <div class="col-md-4 bold">instance id</div>
                    <div class="col-md-8">{{ input.data.instanceId }}</div>
                  </div>
                  <div class="row" v-if="input.type === 'iBeacon'">
                    <div class="col-md-4 bold">uuid</div>
                    <div class="col-md-8">{{ input.data.uuid }}</div>
                  </div>
                  <div class="row" v-if="input.type === 'iBeacon'">
                    <div class="col-md-4 bold">major</div>
                    <div class="col-md-8">{{ input.data.major }}</div>
                  </div>
                  <div class="row" v-if="input.type === 'iBeacon'">
                    <div class="col-md-4 bold">minor</div>
                    <div class="col-md-8">{{ input.data.minor }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">department</div>
                    <div class="col-md-8">{{ getDepartment(input.department_id).name }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">floor</div>
                    <div class="col-md-8">{{ getFloorByDepartment(input.department_id).name }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">marker</div>
                    <div class="col-md-8">
                      <slot v-if="input.data && input.data.marker">
                        <span class="small">{{ input.data.marker.lat }}</span> / <span class="small">{{ input.data.marker.lng }}</span>
                      </slot>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">raw data</div>
                    <div class="col-md-8"><span @click="$bus.$emit('raw', input)" class="pointer text-success bold">show</span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane slide-left" id="tab-data-applications" >
              <div class="row p-l-10 p-r-10">
                <h2 class="p-l-10">Applications</h2>
                <div class="application-box col-md-6"
                  v-for="application in _.sortBy(data.applications, 'name')" v-bind:key="application.id">
                  <h4>{{ application.name }}</h4>
                  <div class="row">
                    <div class="col-md-4 bold">id</div>
                    <div class="col-md-8">{{ application.id }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">ibeacons</div>
                    <div class="col-md-8">{{ application.settings.ibeacons }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">eddystones</div>
                    <div class="col-md-8">{{ application.settings.eddystones }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">native gps</div>
                    <div class="col-md-8">{{ application.settings.gpsgeofences }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">indooratlas</div>
                    <div class="col-md-8">{{ application.settings.indooratlas }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">steerpath</div>
                    <div class="col-md-8">{{ application.settings.steerpath }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">token</div>
                    <div class="col-md-8">
                      <span
                        @click="shownTokens[application.id] = true; update()"
                        v-if="typeof shownTokens[application.id] === 'undefined'"
                        class="pointer text-success bold">show token</span>
                      <div class="token-wrapper" v-if="shownTokens[application.id] === true">
                        <span class="small">{{ applicationTokens[application.id] }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 bold">raw data</div>
                    <div class="col-md-8"><span @click="$bus.$emit('raw', application)" class="pointer text-success bold">show</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

const URL = 'https://testapi.proximi.fi/control-api/organizations'

import axios from 'axios';
import DatePicker from 'vue2-datepicker'

export default {
  name: 'Organization',
  components: { DatePicker },
  props: {
    organization: {
      type: Object,
      default: () => ({

      })
    }
  },
  data: () => ({
    expirationDate: new Date(),
    additional: {},
    showToken: false,
    hasOrganization: false,
    geodata: [],
    data: {
      places: [],
      floors: [],
      departments: [],
      geofences: [],
      applications: [],
      inputs: [],
      red_flows: []
    },
    applicationTokens: {},
    shownPolygons: {},
    shownTokens: {},
    importFile: ''
  }),
  created() {
    window.org = this
    this.$watch('organization', (organization) => {
      this.showToken = false;
      this.hasOrganization = organization && organization.id && organization.id.length > 0;
      this.importFile = '';
      this.shownPolygons = {};
      this.showTokens = {};
      this.applicationTokens = {};
      this.showExpirationDate = true;
      this.expirationDate = this.getExpirationDate(organization);
      this.$nextTick(() => {
        this.$forceUpdate();
      })
      console.log('expiration date set to', this.expirationDate);
      if (this.hasOrganization) {
        this.fetchOrganization();
        this.fetchPackage();
      }
    });
  },
  methods: {
    async geoWipe(entity) {
      let features = []
      if (entity === 'pois') {
        features = this.geodata.filter(f => f.properties.usecase === 'poi').length
      } else if (entity === 'levelchangers') {
        features = this.geodata.filter(f => f.properties.usecase === 'levelchanger').length
      } else if (entity === 'paths') {
        features = this.geodata.filter(f => f.properties.class === 'path').length
      } else {
        features = this.geodata.filter(f => f.properties.class !== 'path' && f.properties.usecase !== 'poi' && f.properties.usecase !== 'levelchanger')
      }
      const r = confirm(`Confirm ${entity} wipe?`)

      if (r) {
        const collection = {
          type: 'FeatureCollection',
          features
        }

        console.log('features to delete: ', features.length)

        try {
          await this.http().delete(`https://api.proximi.fi/v4/geo/features`, { data: collection })
          self.$emit('reload');
          this.$notify({ message: 'Geo Wipe successful' });
        } catch (e) {
          this.$notify({ message: 'Geo Wipe failure' });
        }
      }
    },
    isAdmin() {
      return this.$auth.current.email === 'devs@proximi.io'
    },
    setExpirationDate(date) {
      const data = {
        id: this.organization.id,
        expiresAt: date.getTime() / 1000
      }

      this.$http.put(URL + "/" + this.organization.id, data)
        .then((response) => {
        })
    },
    getExpirationDate(organization) {
      if (organization.expiresAt) {
        return new Date(organization.expiresAt * 1000)
      } else {
        return null
      }
    },
    getDepartment(id) {
      return this.data.departments.find(i => i.id === id) || {}
    },
    getFloorByDepartment(id) {
      const department = this.getDepartment(id)
      return department.id ? this.data.floors.find(i => i.id === department.floor_id) || {} : {}
    },
    getFloor(id) {
      return this.data.floors.find(i => i.id === id) || {}
    },
    isExpired(item) {
      if (this.organization.expiresAt) {
        return (this.organization.expiresAt * 1000) < new Date().getTime()
      } else {
        return null
      }
    },
    http() {
      return axios.create({
        baseURL: 'https://api.proximi.fi',
        timeout: 30000,
        headers: {
          'Authorization': `Bearer ${this.organization.tokens[0]}`
        }
      })
    },
    async fetchOrganization() {
      this.additional = (await this.http().get('/core/current_user')).data;
      this.additional.tokens.forEach((token) => {
        const key = Object.keys(token)[0];
        if (token[key].application_id) {
          this.applicationTokens[token[key].application_id] = key;
        }
      })
    },
    async fetchPackage() {
      this.data = (await this.http().get('/core/package')).data;
      this.geodata = (await this.http().get('/v4/geo/features')).data.features;
    },
    update() {
      this.$forceUpdate();
    },
    exportData() {
      // filename, text
      const element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(JSON.stringify(this.data, null, 4)));
      element.setAttribute('download', `${this.organization.id}.json`);
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
    async exportGeoData() {
      // filename, text
      const element = document.createElement('a');
      const data = (await this.http().get('/v4/geo/features?size=100000')).data
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(JSON.stringify(data, null, 4)));
      element.setAttribute('download', `${this.organization.id}-geo.json`);
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
    async exportGeoItems(entity, filter) {
      let items = this.geodata.filter(filter)
      // filename, text
      const element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(JSON.stringify(items, null, 4)));
      element.setAttribute('download', `${this.organization.id}-${entity}.json`);
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
    onImport(evt) {
      const reader = new FileReader();
      const self = this;
      reader.onload = async (e) => {
        const data = JSON.parse(e.target.result);
        const response = await this.http().post('/core/package', data);
        self.$notify({ message: 'Data was successfully imported' });
        self.$emit('reload');
        this.$refs.importForm.reset();
        self.fetchPackage();
      };
      reader.readAsText(event.target.files[0]);
    },
    importData(evt) {

    },
    async resetPassword() {
      const response = await this.http().post(`/core_auth/reset_password?email=${this.organization.email}`);
      this.$notify({ message: `Password has been successfully reset, email notification was sent to ${this.organization.email}` });
    }
  }
}
</script>

<style>

  table.compact h4 {
    margin-top: 0;
    padding-top: 0;
  }

  table.small-table tr th, table.small-table tr td {
    border-bottom: 1px solid #f3f3f3;
    min-height: 30px;
    height: 30px;
    vertical-align: middle;
  }
  table.small-table tr th {
    font-weight: bold;
    text-transform: uppercase;
    font-size: 10px;
    text-align: right;
  }

  table.small-table tr td {
    font-weight: normal;
    font-size: 12px;
  }

  table.small-table tr td a {
    font-size: 12px;
    font-weight: bold;
  }

  .detail-wrapper {
    height: calc(100% - 90px);
  }

  .token-wrapper {
    width: 200px !important;
    overflow-wrap: break-word !important;
  }

  .break-word {
    overflow-wrap: break-word !important;
  }

  .btn-link {
    float: left;
    margin-right: 20px;
    font-weight: bold;
    margin-top: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    font-size: 11px;
  }

  .btn-link:hover {
    text-decoration: underline;
  }

  .btn-link i {
    padding-right: 5px;
  }

  .floor-box {
    margin: 0px;
    border: 1px solid #f3f3f3;
    min-height: 240px;
  }

  .place-box {
    margin: 0px;
    border: 1px solid #f3f3f3;
    min-height: 190px;
  }

  .departments-box {
    margin: 0px;
    border: 1px solid #f3f3f3;
    min-height: 190px;
  }

  .geofences-box {
    margin: 0px;
    border: 1px solid #f3f3f3;
    min-height: 205px;
  }

  .application-box {
    margin: 0px;
    border: 1px solid #f3f3f3;
    min-height: 200px;
  }

  .h-40 {
    height: 40px;
  }

  .input-ibeacon {
    background-image: url(assets/img/ibeacon_marker.png);
    background-position: top right;
    background-repeat: no-repeat;
    background-size: 38px 48px;
  }

  .input-eddystone {
    background-image: url(assets/img/eddystone_marker.png);
    background-position: top right;
    background-repeat: no-repeat;
    background-size: 38px 48px;
  }

  .btn-disabled {
    cursor: disabled;
    opacity: 0.5;
  }

  .mx-datepicker {
    width: 100%;
  }

  .mx-datepicker input.mx-input {
    border: none;
    box-shadow: none;
    padding: 0;
    margin: 0;
    font-family: "Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    font-weight: bold;
    font-size: 18px;
    height: 23px;
    color: #242d30;
  }
</style>



// WEBPACK FOOTER //
// Organization.vue?696154d2